import { IServiceFactory } from '../../common/types/service-factory';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';
import { TrackingApiService, ITrackingApiService } from 'api/services/tracking-api-service';

export class TrackingApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<ITrackingApiService> {
	public Create(): ITrackingApiService {
		return new TrackingApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}

